import * as yup from 'yup';

export const FORM_ID = 'manage-signature-page-form';

export interface FormValues {
  title: string;
  body: string;
  signatureFields: SignatureField[];
  allowAdvisersOverrideSignaturePage: boolean;
}

export const validation = (canEditTitleAndBody: boolean) =>
  yup.object().shape({
    title: canEditTitleAndBody
      ? yup
          .string()
          .trim()
          .required('Title is required.')
      : yup.string(),
    body: canEditTitleAndBody
      ? yup
          .string()
          .trim()
          .required('Body text is required.')
      : yup.string(),
    signatureFields: yup.array().min(1, 'At least one signature field is required.'),
    allowAdvisersOverrideSignaturePage: yup.boolean(),
  });

export interface SignatureField {
  id?: string;
  label: string;
}

export interface SignaturePageContent {
  title?: string;
  body?: string;
  signatureFields: SignatureField[];
}

export const DEFAULT_SIGNATURE_FIELD_LABEL = 'Signature';

export const createSignatureField = (index: number): SignatureField => ({
  id: `sig-${index + 1}`,
  label: DEFAULT_SIGNATURE_FIELD_LABEL,
});

export const cloneSignaturePageContent = (content: SignaturePageContent): SignaturePageContent => ({
  title: content?.title || '',
  body: content?.body || '',
  signatureFields: (content?.signatureFields || []).map((field, index) => ({
    ...field,
    id: field.id || createSignatureField(index).id,
    label: field.label || '',
  })),
});
